// extracted by mini-css-extract-plugin
export var scrollArea = "_nt-0";